import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import { ICallOff } from 'src/models/callOffs/types';
import RejectInboxMailButton from 'src/shared/CallOffs/RejectInboxMailButton';
import BidPicker from 'src/shared/BidPicker';
import { useOpenCallOffPreview } from 'src/models/callOffs/hooks';
import { useCurrentSidebar } from 'src/shared/InfoSidebar/hooks';
import { SidebarMode } from 'src/shared/InfoSidebar/types';

interface IProps {
  callOff: ICallOff;
}

export const CallOffsActionsSingle: FC<IProps> = props => {
  const { callOff } = props;
  const { id, bid, linkedBid, nextCallOff } = callOff;
  const onOpenCallOffPreview = useOpenCallOffPreview();
  const currentSidebar = useCurrentSidebar();

  const onFinish = useCallback(() => {
    if (currentSidebar?.mode === SidebarMode.CALL_OFF_INFO) {
      onOpenCallOffPreview(nextCallOff && { id: nextCallOff.id, isRead: nextCallOff.isRead });
    }
  }, [currentSidebar, nextCallOff, onOpenCallOffPreview]);

  return (
    <ul className={styles.actionsSingleTender}>
      <li className={classNames(styles.actionSingleTender, styles.addToWsAction)} onClick={e => e.stopPropagation()}>
        <BidPicker
          selectedCallOffs={[callOff]}
          placeHolderBid={bid || linkedBid}
          mode={'short'}
          showTooltip
          eventSource={'CallOffsSingleEmails'}
          onChange={onFinish}
        />
      </li>

      <li className={classNames(styles.actionSingleTender, styles.rejectAction)} onClick={e => e.stopPropagation()}>
        <RejectInboxMailButton selectedMailIds={[id]} onComplete={onFinish} />
      </li>
    </ul>
  );
};
export default CallOffsActionsSingle;
